module.exports = __webpack_public_path__ + "static/media/android.f4c32106.svg";